import Big from "big.js";

import { defaultSlippage } from "../constants/defaultSlippage";

export const getTokenAmountWithSlippage = (
  value: Big,
  slippage: number = defaultSlippage
) => value.mul(1 - slippage).round(0, Big.roundDown);
